/* AMTENDENCY — abas de conteúdo da PDP.

   O Liquid entrega todos os painéis visíveis de propósito: sem JavaScript a
   página continua legível. Aqui eles passam a alternar, com teclado (setas,
   Home/End) como manda o padrão de tablist. */
(function () {
  function monta(caixa) {
    if (caixa.dataset.amAbasPronto) return;
    caixa.dataset.amAbasPronto = '1';

    var abas = [].slice.call(caixa.querySelectorAll('.am-abas__aba'));
    var paineis = [].slice.call(caixa.querySelectorAll('.am-abas__painel'));
    if (abas.length < 2) return;

    function mostra(i, foco) {
      abas.forEach(function (a, j) {
        var ativo = j === i;
        a.setAttribute('aria-selected', ativo ? 'true' : 'false');
        a.tabIndex = ativo ? 0 : -1;
      });
      paineis.forEach(function (pn, j) { pn.hidden = j !== i; });
      if (foco) abas[i].focus();
    }

    abas.forEach(function (a, i) {
      a.addEventListener('click', function () { mostra(i); });
      a.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % abas.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + abas.length) % abas.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = abas.length - 1;
        if (n === null) return;
        e.preventDefault();
        mostra(n, true);
      });
    });

    mostra(0);
  }

  function inicia() { document.querySelectorAll('[data-am-abas]').forEach(monta); }
  document.addEventListener('DOMContentLoaded', inicia);
  document.addEventListener('shopify:section:load', inicia);
  if (document.readyState !== 'loading') inicia();
})();
